import React from 'react';
import { useIntl, useModel } from 'umi';
import { ModalForm, ProFormText } from '@ant-design/pro-form';

import type { DoubleCallParams } from './data';
import { DoubleCallPhone } from './service'

type ModalProps={
  mobile?: string | number;
  children?: JSX.Element;
}


const DoubleCallModal = (props: ModalProps) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.DoubleCallModal.index', intl.formatMessage);

  const {children,mobile}=props;

  const {initialState} = useModel('@@initialState');
  const { currentUser } = initialState || {};

  const handleFinish= async (values: DoubleCallParams)=>{
    const res= await DoubleCallPhone(values)
    const {code}=res
    if(code===200){
      // 请求成功
      // message.success(t('t0', '呼叫成功'))
      // return true
    }
    // message.error(t('t1', '呼叫失败'))
    return true

  }
  return (
    <ModalForm
      title={t('t2', '拨打电话')}
      layout="horizontal"
      width={450}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 15 }}
      trigger={children}
      modalProps={{
        destroyOnClose:true
      }}
      onFinish={handleFinish}
    >
      <ProFormText
        label={t('t3', '客户电话')}
        initialValue={mobile}
        fieldProps={{
          type:"number"
        }}

        name={'calledNumber'}
        rules={[{ required: true, message: t('t4', '请输入客户电话号码') }]}
      />
      <ProFormText
        label={t('t5', '我的电话')}
        fieldProps={{
          type:"number"
        }}
        name={'callerNumber'}
        initialValue={currentUser?.mobile}
        rules={[{ required: true, message: t('t6', '请输入电话号码') }]}
      />
    </ModalForm>


  );
};

export default DoubleCallModal;
